/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DemandeManutentionStatutValues } from '../models/demande-manutention-statut-values';
import { DemandeManutentionStatutValuesRequest } from '../models/demande-manutention-statut-values-request';
import { DemandeTransportCountDto } from '../models/demande-transport-count-dto';
import { DemandeTransportDto } from '../models/demande-transport-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des demandes de transport
 */
@Injectable({
  providedIn: 'root',
})
export class DemandesTransportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation demandeTransportGetList
   */
  static readonly DemandeTransportGetListPath = '/api/demandes-transport/list';

  /**
   * Renvoie la liste des demandes de transport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DemandeTransportDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DemandeTransportDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de transport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetList(params?: {
  }): Observable<Array<DemandeTransportDto>> {

    return this.demandeTransportGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DemandeTransportDto>>) => r.body as Array<DemandeTransportDto>)
    );
  }

  /**
   * Path part for operation demandeTransportGetListCount
   */
  static readonly DemandeTransportGetListCountPath = '/api/demandes-transport/list/count';

  /**
   * Renvoie le nombre de demandes de transport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportGetListCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetListCount$Response(params?: {
  }): Observable<StrictHttpResponse<DemandeTransportCountDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportGetListCountPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportCountDto>;
      })
    );
  }

  /**
   * Renvoie le nombre de demandes de transport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportGetListCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetListCount(params?: {
  }): Observable<DemandeTransportCountDto> {

    return this.demandeTransportGetListCount$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportCountDto>) => r.body as DemandeTransportCountDto)
    );
  }

  /**
   * Path part for operation demandeTransportLoadListWithStatus
   */
  static readonly DemandeTransportLoadListWithStatusPath = '/api/demandes-transport/load-list/{demandeManutentionStatutValue}';

  /**
   * Renvoie la liste des demandes de transport (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportLoadListWithStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportLoadListWithStatus$Response(params: {

    /**
     * Statut à afficher
     */
    demandeManutentionStatutValue: DemandeManutentionStatutValuesRequest;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportLoadListWithStatusPath, 'post');
    if (params) {
      rb.path('demandeManutentionStatutValue', params.demandeManutentionStatutValue, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de transport (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportLoadListWithStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportLoadListWithStatus(params: {

    /**
     * Statut à afficher
     */
    demandeManutentionStatutValue: DemandeManutentionStatutValuesRequest;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.demandeTransportLoadListWithStatus$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation demandeTransportGetWithStatus
   */
  static readonly DemandeTransportGetWithStatusPath = '/api/demandes-transport/{demandeManutentionStatutValue}/{id}';

  /**
   * Renvoie la demande de transport spécifiée avec le statut spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportGetWithStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetWithStatus$Response(params: {

    /**
     * Statut de la demande de transport
     */
    demandeManutentionStatutValue: DemandeManutentionStatutValues;

    /**
     * Identifiant de la demande de transport
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportGetWithStatusPath, 'get');
    if (params) {
      rb.path('demandeManutentionStatutValue', params.demandeManutentionStatutValue, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Renvoie la demande de transport spécifiée avec le statut spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportGetWithStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetWithStatus(params: {

    /**
     * Statut de la demande de transport
     */
    demandeManutentionStatutValue: DemandeManutentionStatutValues;

    /**
     * Identifiant de la demande de transport
     */
    id: number;
  }): Observable<DemandeTransportDto> {

    return this.demandeTransportGetWithStatus$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

  /**
   * Path part for operation demandeTransportPost
   */
  static readonly DemandeTransportPostPath = '/api/demandes-transport';

  /**
   * Crée une demande de transport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportPost$Response(params: {

    /**
     * Demande de transport
     */
    body: DemandeTransportDto
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Crée une demande de transport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportPost(params: {

    /**
     * Demande de transport
     */
    body: DemandeTransportDto
  }): Observable<DemandeTransportDto> {

    return this.demandeTransportPost$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

  /**
   * Path part for operation demandeTransportPut
   */
  static readonly DemandeTransportPutPath = '/api/demandes-transport/{id}';

  /**
   * Met à jour la demande de transport spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportPut$Response(params: {

    /**
     * Identifiant de la demande de transport à mettre à jour
     */
    id: number;

    /**
     * Demande de transport
     */
    body: DemandeTransportDto
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Met à jour la demande de transport spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportPut(params: {

    /**
     * Identifiant de la demande de transport à mettre à jour
     */
    id: number;

    /**
     * Demande de transport
     */
    body: DemandeTransportDto
  }): Observable<DemandeTransportDto> {

    return this.demandeTransportPut$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

  /**
   * Path part for operation demandeTransportDelete
   */
  static readonly DemandeTransportDeletePath = '/api/demandes-transport/{id}';

  /**
   * Supprime la demande de transport spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportDelete$Response(params: {

    /**
     * Identifiant de la demande de transport à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la demande de transport spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportDelete(params: {

    /**
     * Identifiant de la demande de transport à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.demandeTransportDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation demandeTransportCancel
   */
  static readonly DemandeTransportCancelPath = '/api/demandes-transport/cancel/{id}';

  /**
   * Annule la demande de transport spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportCancel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportCancel$Response(params: {

    /**
     * Identifiant de la demande de transport à annuler
     */
    id: number;

    /**
     * Demande de transport
     */
    body: DemandeTransportDto
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportCancelPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Annule la demande de transport spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportCancel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportCancel(params: {

    /**
     * Identifiant de la demande de transport à annuler
     */
    id: number;

    /**
     * Demande de transport
     */
    body: DemandeTransportDto
  }): Observable<DemandeTransportDto> {

    return this.demandeTransportCancel$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

  /**
   * Path part for operation demandeTransportNotifyExternalUpdate
   */
  static readonly DemandeTransportNotifyExternalUpdatePath = '/api/demandes-transport/notify-external-update';

  /**
   * Notifie la modification de demandes de transport suite à un accès direct à la base de données
   * (utilisé par Patrol).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportNotifyExternalUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportNotifyExternalUpdate$Response(params: {

    /**
     * Identifiants des demandes de transport
     */
    body: Array<number>
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportNotifyExternalUpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Notifie la modification de demandes de transport suite à un accès direct à la base de données
   * (utilisé par Patrol).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportNotifyExternalUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeTransportNotifyExternalUpdate(params: {

    /**
     * Identifiants des demandes de transport
     */
    body: Array<number>
  }): Observable<boolean> {

    return this.demandeTransportNotifyExternalUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation demandeTransportGetEnAttenteForConteneur
   */
  static readonly DemandeTransportGetEnAttenteForConteneurPath = '/api/demandes-transport/en-attente/{conteneurId}';

  /**
   * Renvoie la demande de transport en attente pour le conteneur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportGetEnAttenteForConteneur()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetEnAttenteForConteneur$Response(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportGetEnAttenteForConteneurPath, 'get');
    if (params) {
      rb.path('conteneurId', params.conteneurId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Renvoie la demande de transport en attente pour le conteneur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportGetEnAttenteForConteneur$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetEnAttenteForConteneur(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;
  }): Observable<DemandeTransportDto> {

    return this.demandeTransportGetEnAttenteForConteneur$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

  /**
   * Path part for operation demandeTransportGetEnCoursForConteneur
   */
  static readonly DemandeTransportGetEnCoursForConteneurPath = '/api/demandes-transport/en-cours/{conteneurId}';

  /**
   * Renvoie la demande de transport en cours pour le conteneur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeTransportGetEnCoursForConteneur()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetEnCoursForConteneur$Response(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesTransportService.DemandeTransportGetEnCoursForConteneurPath, 'get');
    if (params) {
      rb.path('conteneurId', params.conteneurId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Renvoie la demande de transport en cours pour le conteneur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeTransportGetEnCoursForConteneur$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeTransportGetEnCoursForConteneur(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;
  }): Observable<DemandeTransportDto> {

    return this.demandeTransportGetEnCoursForConteneur$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

}
